import { useCallback } from "react";
import { shallowEqual, useDispatch, useSelector, useStore } from "react-redux";

import { INovelState } from "./reducers";
import {
    NovelGalleryAction,
    NovelGalleryActionActionType,
    GeneralNovelGalleryDispatch,
    NovelGalleryStore,
} from "./galleryTypedRedux";

export function useNovelCustomerStore(): NovelGalleryStore {
    return useStore<INovelState, NovelGalleryAction<NovelGalleryActionActionType>>();
}

export function useNovelCustomerDispatch(): GeneralNovelGalleryDispatch {
    return useDispatch<GeneralNovelGalleryDispatch>();
}

export function useNovelCustomerSelector<TSelected>(
    selector: (state: INovelState) => TSelected,
    equalityFn: (left: TSelected, right: TSelected) => boolean = shallowEqual, // we default to shallow equal even though redux does not now
): TSelected {
    return useSelector<INovelState, TSelected>(useCallback(selector, [selector]), equalityFn);
}
